import { ProductButton } from '@issuu/silkscreen';
import React from 'react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';

import { HEADER_Z_INDEX } from '../constants';

const screenReaderOnly = css`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

export const ScreenReaderSpan = styled.span`
    ${screenReaderOnly}
`;
export const ScreenReaderH1 = styled.h1`
    ${screenReaderOnly}
`;
export const ScreenReaderH2 = styled.h2`
    ${screenReaderOnly}
`;
export const ScreenReaderH3 = styled.h3`
    ${screenReaderOnly}
`;
export const ScreenReaderH4 = styled.h4`
    ${screenReaderOnly}
`;
export const ScreenReaderH5 = styled.h5`
    ${screenReaderOnly}
`;
export const ScreenReaderH6 = styled.h6`
    ${screenReaderOnly}
`;

const SkipNavWrapper = styled.div`
    :focus-within {
        position: absolute;
        top: 3.5rem;
        left: 2rem;
        z-index: ${HEADER_Z_INDEX + 1};
    }

    :not(:focus-within) {
        ${screenReaderOnly}
    }
`;

export const SkipNavButton: React.FC = () => {
    const [skipNavElement, setSkipNavElement] = useState<HTMLElement>();
    useEffect(() => {
        const elm = document.getElementById('skipNav');
        if (elm) {
            setSkipNavElement(elm);
        } else {
            const newSkip = document.createElement('nav');
            newSkip.id = 'skipNav';
            document.body.prepend(newSkip);
            setSkipNavElement(newSkip);
        }
    }, []);
    if (!skipNavElement) return null;
    const mainElement = document.querySelector('main');
    if (!mainElement) return null;
    const handler = () => {
        // Need a tab index to be able to focus
        mainElement.setAttribute('tabIndex', '-1');
        mainElement.focus();
        // But we clean it up after using it
        mainElement.removeAttribute('tabIndex');
    };
    skipNavElement.setAttribute('aria-label', 'Skip to main content');
    return ReactDOM.createPortal(
        <SkipNavWrapper>
            <ProductButton onClick={handler} role="link" variant="secondary">
                Skip to main content
            </ProductButton>
        </SkipNavWrapper>,
        skipNavElement,
    );
};
